import React from 'react';
import {connect} from 'react-redux';
import BaseConsumption from 'components/BaseConsumption';
import {getKTPConsumptionByApp} from 'actions/consumption';
import {getSeries} from 'utils/tool';
class KTPConsumption extends React.Component {
    columns = [
        {
            title: 'Time',
            dataIndex: 'day',
            key: 'day',
            sorter:true
        },{
            title: 'Quality Detection',
            dataIndex: 'quality_detect',
            key: 'quality_detect',
            sorter:true
        },{
            title: 'Recognition',
            dataIndex: 'cert_recognize',
            key: 'cert_recognize',
            sorter:true
        }
    ]

    renderSub=(data)=>{
        const total = data.total || {};
        return <p>(Quality Detection: <span style={{color:'#6D74F4'}}>{total.quality_detect||0}</span> ,Recognition: <span style={{color:'#6D74F4'}}>{total.cert_recognize || 0}</span>)</p>;
    }

    chartSeries = (chartData)=>{
        const xdata = [],data1=[],data2=[];
        chartData.forEach(item=>{
            xdata.push(item.day);
            data1.push({
                value:item.quality_detect
            });
            data2.push({
                value:item.cert_recognize
            });
        });
        const series = [getSeries(data1,'Quality Detection','#8A90FF'),getSeries(data2,'Recognition','#e35df4')];
        return {xdata,series};
    }

    render() {
        return (
            <BaseConsumption
                columns={this.columns}
                subTitle={this.renderSub}
                chartSeries={this.chartSeries}
                title='Indonesia ID card'
                getInfoPromise={getKTPConsumptionByApp}
            />
        );

    }

}


function select(state) {
    return {
        account: state.account.info
    };
}
export default connect(select)(KTPConsumption);



// WEBPACK FOOTER //
// ./src/pages/KTPConsumption/index.js